// McBlogViewer Widget

module.exports = (fox) => {
	const $ = fox.jQuery;

	fox.registerOptions('~#mcBlog #mcBlog', {
		'hooks.onPrepareEmbeddedWidgets': function () {
			const viewer = this.rwom1('.McBlogViewer');

			this.setTemplateOptions('years', fox.utils.getRange(2014, new Date().getFullYear()));
			this.bindTemplateVariables(viewer.bindData, ['fetching']);
		}
	}, true, {});
	
	fox.registerWidget('McBlogViewer', {
		configure() {
			this.CACHE = {};
			this._collection = [];
			this.bindData = {
				fetching: false
			};
			this._fields = [
				'id', 'shortContent.content', 'shortContent.postId', 'shortContent.typeContent', 'shortContent.position',
				'shortContent.type', 'shortContent.addDate', 'title', 'publishDate', 'status', 'rating.voters',
				'commentsSum.total', 'tags.postId', 'tags.title', 'contents.content', 'contents.postId', 'contents.typeContent',
				'contents.position', 'contents.type', 'contents.addDate', '_comments'
			];
			this._popularFields = [
				'id', 'shortContent.content', 'shortContent.type', 'title', 'publishDate', 'rating.voters',
				'commentsSum.total'
			];

			this.registerOptions('', {
				widgets: {
					postWindow: {
						widget: 'McBlog_PostWindow'
					},
					getPostApi: {
						widget: 'Api',
						method: 'McBlog.getPost',
						handleWom: {
							postLoadedSuccess: {
								event: 'success',
								widget: '@this',
								callback: '@parent:postLoadedSuccess'
							}
						}
					},
					searchPostsApi: {
						widget: 'Api',
						method: 'McBlog.searchPost',
						'handleWom.searchPostApiSuccess': {
							event: 'success',
							widget: '@this',
							callback: '@parent:searchPostApiSuccess'
						}
					},
					postList: {
						widget: 'Grid_List_Widgets',
						widgetsAliasPrefix: 'mc_post',
						columns: $(document).width() < 767 ? ['#mcb-left-container'] : ['#mcb-left-container', '#mcb-right-container'],
						widgetsConfig: {
							'widgets.shareThis': {
								widget: 'McBlog_ShareThis',
								'onShareClick.target': '.mcb-share-block a'
							},
							template: 'mcBlog_post_list_item',
							'hooks.onStopAddedToDom': this.listItemAddedToDom //necessary scope (this === childWidget)
						},
						handleWom: {
							activateWidget: {
								event: 'activate',
								widget:'@this',
								callback: fox.bind(function() {
									this.filterPosts(true);
								}, this)
							}
						}
					},
					popularPostList: {
						widget: 'Grid_List_Widgets',
						widgetsAliasPrefix: 'mc_popular_post',
						'embed.container': '#mcb-popular-posts',
						'widgetsConfig.template': 'mcBlog_popular_post_list_item',
						visibleItems: 3,
						handleWom: {
							activateWidget: {
								event: 'activate',
								widget:'@this',
								callback: fox.bind(function() {
									this.loadPopularPosts();
								}, this)
							}
						}
					},
					filterForm: {
						widget: 'Form',
						loadValuesOnRun: false,
						container: '@parent @parent',
						formElements: {
							yearSort: {
								element: '[name=year]',
								updateNodeOnAddToDom: true,
								defaultValue: 0
							},
							monthSort: {
								element: '[name=month]',
								updateNodeOnAddToDom: true,
								defaultValue: 0
							}
						},
						submit: {
							event: 'click',
							target: '#show-posts'
						},
						'hooks.onSubmit': '@parent:filterPosts'
					},
					popularPostsDl: {
						widget: 'Datalayer',
						method: 'McBlog.getPopularPosts',
						limit: 3,
						fields: this._popularFields,
						transitParameters: {
							lang: fox.i18n.lang
						},
						'handleWom.dataLoad': {
							event: 'loaded',
							widget: '@this',
							callback: '@parent:popularPostLoaded'
						}
					}
				},
				handleDom: {
					showPostWindow: {
						event: 'click',
						target: '.mcb-show-post',
						targetWidget: '#postList .Widget',
						callback: 'showPost'
					},
					showPopularPostWindow: {
						event: 'click',
						target: '.fq-p-title a',
						targetWidget: '#popularPostList .Widget',
						callback: 'showPost'
					},
					searchPosts: {
						event: 'keydown',
						target: '[name=search]',
						targetWidget: '@parent',
						eventChecker: function (e) {
							return !e.altKey && !e.ctrlKey && !e.shiftKey && !e.metaKey && e.keyCode === 13;
						},
						callback: 'searchPosts'
					},
					changeSelect: {
						event: 'change',
						target: '.mcb-select select',
						targetWidget: '@parent',
						callback: 'changeSelect'
					}
				},
				'handleWom.elsCreated': {
					event: 'formElementsCreated',
					widget: '#filterForm',
					callback: function (obj, form) {
						fox.each(form._defaults, function (val, key) {
							form.rwom1(['#', key].join('')).setValue(val);
						});
					}
				},
				'handleWom.listenNav': {
					event: 'modified_1',
					widget: fox.Navigator,
					callback: 'showFromUrl',
					'params.listenHistory': true
				},
				'handleWom.parentAddedToDom': {
					event: 'addedToDom',
					widget: '@parent',
					callback: function (params, scope) {
						fox.each(scope.dom('.mcb-select select'), function (node) {
							this.setSelectValue($(node));
						}, this);
					},
					params: {
						listenHistory: true
					}
				},
				'handleWom.handleLangSwitch': {
					widget: '@root ~.Promo_Header #langSwitcher',
					event: 'langSwitched',
					callback: '_switchLang'
				}
			});
		
			this.callParent('configure', arguments);
		},

		changeSelect: function (el) {
			this.setSelectValue($(el));
		},

		setSelectValue: function ($el) {
			$el.prev().text($el.find('option:selected').text());
		},

		showFromUrl: function (postId) {
			var c, postData, pw;

			if (!fox.isNumeric(postId)) return false;

			pw = this.rwom1('#postWindow');

			if (!fox.isEmpty(postId)) {
				if (postData = this.getPostFromCollection(postId)) {
					pw.setPostData(postData.postData, postData.c);

					pw.opened ? pw.showPost('fadeInRight') : pw.show();
				} else {
					this.getPostFromServer(postId);
				}
			}
		},

		getPostFromServer: function (id) {
			this.rwom1('#getPostApi').send({
				id: id,
				fields: this._fields,
				transitParameters: {
					lang: fox.i18n.lang
				}
			});

			return this;
		},

		searchPosts: function (el) {
			var s;

			s = el.value;
			el.value = '';

			this.rwom1('#searchPostsApi').send({
				phrase: s,
				transitParameters: {
					status: 2,
					lang: fox.i18n.lang
				},
				fields: this._fields
			});
		},

		postLoadedSuccess: function (res) {
			res = res.answer.response;

			if (!fox.isEmpty(res)) {
				this._prepareRating(res.collection[0]);
				this.rwom1('#postWindow')
					.setPostData(res.collection[0])
					.show();
			}
		},

		running: function () {
			this.filterPosts();
			this.loadPopularPosts();

			this.callParent('running', arguments);
		},

		getApi: function (hashAlias) {
			let dl =  this.embedWidget(hashAlias, 'Datalayer', {
				method: 'McBlog.get',
				fields: this._fields,
				transitParameters: {
					status: 2
				},
				limit: 444,
				'handleWom.loaded': {
					event: 'loaded',
					widget: '@this',
					callback: '@parent:dlLoadSuccess'
				} 
			});
			
			dl.run();
			return dl;
		},

		dlLoadSuccess: function (o, dl, evAlias) {
			var c;

			c = dl.getCollection();
			this.CACHE[dl.getAlias()] = c;

			if (this.activeHashData === dl.getAlias()) {
				this.renderPostList(c);
			}

			dl.removeSelf();
		},

		searchPostApiSuccess: function (res) {
			res = res.answer.response;

			this.renderPostList(res.collection);
			this.activeHashData = false;
		},

		loadData: function (params) {
			var dl, hash;

			hash = this.getHashKey(params);

			if (!this.getEmbeddedWidget(hash)) {
				dl = this.getApi(hash);
				dl.setTransitParameter(params);

				this.bindData.fetching = true;
				dl.load().then(() => {
					this.bindData.fetching = false;
				});
			}
		},

		getCachedData: function (params, direction) {
			var year, month, cachedHash;

			year = parseInt(params.yearSort);
			month = parseInt(params.monthSort);

			if (direction === 'next') {
				if (month == 12) {
					month = 1;
					year++;
				} else {
					month++;
				}
			} else if (direction === 'prev') {
				if (month == 1) {
					month = 12;
					year--;
				} else {
					month--;
				}
			}

			cachedHash = this.getHashKey([year, month, fox.i18n.lang]);

			if (!this.CACHE.hasOwnProperty(cachedHash)
				&& !this.getEmbeddedWidget(cachedHash)) {
				var dl = this.getApi(cachedHash);
				dl.cacheQuery = true;
				//dl.setTransitParameter({yearSort: year, monthSort: month, lang: fox.i18n.lang});

				dl.load();
			}

			return this;
		},

		getHashKey: function (obj) {
			return window.btoa(fox.toArray(obj).sort().join(':'));
		},

		popularPostLoaded: function (obj, dl) {
			this._collection2 = dl.getCollection();

			this.rwom1('#popularPostList').setCollection(this._collection2, true);
		},

		renderPostList: function (collection) {
			$(this.getParent().dom1('#mcb-f-items')).text(collection.length);
			$(this.getParent().dom1('.mcb-timeline-wrapper')).html('');

			this.rwom1('#postList').setCollection(collection, true);
			this._collection = collection;

			return this;
		},

		showPost: function (el, evAlias, performer, event) {
			return;
			var collectionKey, c;

			collectionKey = performer.getOption('externalObj._key');
			
			if (typeof collectionKey !== 'undefined') {
				c = evAlias === 'showPostWindow' ? this._collection : this._collection2;

				this.rwom1('#postWindow')
					.setPostData(c[collectionKey], c)
					.show();
			}
		},

		listItemAddedToDom: function () {
			var fn, $el, $imgs;

			$el = $(this.element);

			fox.each(this.dom('img'), function (img) {
				fox.dom.on('error', img, function () {
					$(img).parent().hide();
				});
			});

			setTimeout(function () {
				$el.removeClass('fadeIn');
			}, 410);

			fn = function () {
				var fadeEffect, $dot, dotTopPos, $itemArrow, $tDotTemplate, itemPubMonth, $dotsContainer;

				$dotsContainer = $(this.visualParent.dom1('.mcb-timeline-wrapper'));
				$itemArrow = $(this.dom1('.mcb-post-arrow'));
				$tDotTemplate = $('<div class="mcb-dot-item"></div>');
				itemPubMonth = fox.utils.dateFormat('%b', this.getOption('externalObj.publishDate'));
				
				dotTopPos = $itemArrow.offsetParent().offset().top - $dotsContainer.offset().top;

				$dotsContainer.children().each(function (i, el) {
					var sub;

					sub = dotTopPos + 33 - $(el).position().top;
					sub = sub < 0 ? sub *= -1 : sub;

					if (sub <= 72 && sub >= 0) {
						dotTopPos += 72;
						$itemArrow.css('top', $itemArrow.position().top + 72);
					}
				});

				fadeEffect = this.getOption('embed.container') === '#mcb-left-container'
					? 'mcb-animated fadeInLeft'
					: 'mcb-animated fadeInRight';

				$tDotTemplate
					.addClass(fadeEffect)
					.css({
						top: dotTopPos + 33
					})
					.appendTo($dotsContainer);
			};

			setTimeout(fox.bind(fn, this), 1600);
		},

		filterPosts: function (onActivate) {
			var formVals = this.rwom1('#filterForm').collectData();

			/* if (fox.isEmpty(formVals)) {
				formVals = {
					yearSort: new Date().getFullYear(),
					monthSort: 0
				};
			} */

			formVals['lang'] = fox.i18n.lang;

			if (this.activeHashData === this.getHashKey(formVals) && !onActivate) {return;}

			this.activeHashData = this.getHashKey(formVals);

			if (this.CACHE.hasOwnProperty(this.activeHashData)) {
				this.renderPostList(this.CACHE[this.activeHashData]);
			} else {
				this.loadData(formVals);
			}

			return this; 
		},

		getPostFromCollection: function (postId) {
			var postData, fn;

			fn = function (c, id) {
				var _pd;

				if (typeof c === 'undefined')
					return false;

				fox.each(c, function (val) {
					if (val.id === parseInt(id)) {
						_pd = val;

						throw fox.break;
					}
				});

				return _pd;
			};
			
			if (postData = fn(this._collection, postId)) {
				this._prepareRating(postData);
				return {postData: postData, c: this._collection};
			} else if (postData = fn(this._collection2, postId)) {
				this._prepareRating(postData);
				return {postData: postData, c: this._collection2};
			} else {
				return false;
			}
		},

		loadPopularPosts: function () {
			this.rwom1('#popularPostsDl').setTransitParameter('lang', fox.i18n.lang).load();
			return this;
		},

		_switchLang: function() {
			this.filterPosts();
			this.loadPopularPosts();
		},
		
		_prepareRating: function(postData) {
			if (!fox.isEmpty(postData.rating.collection)) {
				var dl = fox.createDl();
				dl.setCollection(postData.rating.collection);
				postData._rating = {voters: dl.getObjectValue('voters')};
			} else {
				postData._rating = {voters: 0};
			}
		}

	}, 'Controller');

};


// WEBPACK FOOTER //
// ../common/widget/sitepage/mcBlog/mcBlogViewer.es.js